module.exports = __webpack_public_path__ + "static/media/risk.448baddf.svg";